import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCertificate = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17}
    height={17}
    fill="currentColor"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M3.473 2.266C3.603.36 5.833-.602 7.309.61l.424.349A.85.85 0 0 0 8.831.943l.414-.361c1.44-1.256 3.697-.36 3.883 1.542l.054.546a.85.85 0 0 0 .788.765l.548.038c1.906.13 2.868 2.36 1.655 3.836l-.348.424a.85.85 0 0 0 .016 1.098l.36.414c1.256 1.44.36 3.697-1.541 3.883l-.546.054a.85.85 0 0 0-.766.788l-.037.548c-.13 1.906-2.36 2.868-3.836 1.655l-.424-.348a.85.85 0 0 0-1.099.016l-.413.36c-1.44 1.256-3.697.36-3.884-1.541l-.053-.546a.85.85 0 0 0-.788-.766l-.548-.037C.36 13.18-.602 10.95.61 9.475l.35-.425a.85.85 0 0 0-.016-1.099L.582 7.54C-.674 6.1.222 3.843 2.124 3.656l.546-.053a.85.85 0 0 0 .765-.788l.038-.548Zm2.884-.496a.85.85 0 0 0-1.388.598l-.037.548a2.35 2.35 0 0 1-2.115 2.179l-.547.053a.85.85 0 0 0-.558 1.405l.361.414a2.35 2.35 0 0 1 .045 3.036l-.348.424a.85.85 0 0 0 .598 1.387l.548.038a2.35 2.35 0 0 1 2.179 2.115l.053.547a.85.85 0 0 0 1.405.557l.414-.36a2.35 2.35 0 0 1 3.036-.045l.424.348a.85.85 0 0 0 1.387-.599l.038-.547a2.35 2.35 0 0 1 2.115-2.179l.547-.053a.85.85 0 0 0 .557-1.405l-.36-.414a2.35 2.35 0 0 1-.045-3.036l.348-.424a.85.85 0 0 0-.599-1.388l-.547-.037a2.35 2.35 0 0 1-2.179-2.115l-.053-.547a.85.85 0 0 0-1.405-.558l-.414.361a2.35 2.35 0 0 1-3.036.045z"
      clipRule="evenodd"
    />
    <path d="M7.324 9.638 5.89 8.204a.8.8 0 0 0-1.132 1.131l2 2a.8.8 0 0 0 1.132 0l4-4a.8.8 0 0 0-1.132-1.132z" />
  </svg>
);
export default SvgCertificate;
